<template lang="pug">
ods-module.loyalty-programs-detail(v-if="getProgramState")
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.catalog') }}
      span {{ data.desccata }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.cancelpointafteraward') }}
      span {{ this.actualizarCampo(data.indanpto) }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.redemptionperiodicity') }}
      span {{ data.percanje }}
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.lastredemtion') }}
      span {{ data.fechucan | formatDateLocale }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.nextredemtion') }}
      span {{ data.fechpcan | formatDateLocale }}
    //- div.loyalty-programs-detail__flex-33-percent-column
    //-   h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.immediateReward') }}
    //-   span {{ data.inprinme }}
ods-module.loyalty-programs-detail(v-else v-loading="true" loading-spinner="spinner")
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'PremioTable',
  computed: {
    ...mapGetters({
      getProgramState: 'getProgramState'
    })
  },
  methods: {
    actualizarCampo (data) {
      if (data === 0) {
        return this.$t('loyalty.no')
      }
      if (data === 1) {
        return this.$t('loyalty.yes')
      }
    }
  }
}
</script>
<style lang="scss">
.loyalty-programs-detail{
  padding: rem(24) rem(32);
  &__flex-row{
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   margin-top: rem(16);
  }

  &__flex-33-percent-column{
    width: 33.33%;
    margin-bottom: rem(15);
  }

  &__divisor{
   border: 1px solid #F0F0F0;
   margin: rem(32) 0 rem(32) 0;
  }

  &__title{
    font-size: rem(16);
    line-height: rem(24);
    margin-bottom: rem(16);
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(12);
    line-height: rem(24);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
  }
}
</style>
